import React from 'react';
import { MdAddPhotoAlternate } from 'react-icons/md';

interface OCRInfo {
  confidence?: number | null;
}

interface Props {
  previewSrc: string | null;
  file?: File | null;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onOpenPicker?: () => void;
  ocrLoading?: boolean;
  ocrInfo?: OCRInfo | null;
  onChangeImage?: () => void;
}

const UploadReceiptImageWeb: React.FC<Props> = ({ previewSrc, file, onFileChange, onOpenPicker, ocrLoading, ocrInfo, onChangeImage }) => {
  return (
    <div style={styles.card}>
      <div style={styles.title}>Receipt Image</div>
      <div style={styles.dropzone} onClick={onOpenPicker}>
        {previewSrc ? (
          <img src={previewSrc} style={styles.preview} alt="receipt" />
        ) : (
          <div style={styles.placeholder}>
            <div style={styles.icon}>
              <MdAddPhotoAlternate size={48} color="#9CA3AF" />
            </div>
            <div style={styles.placeholderTitle}>Tap to select receipt image</div>
            <div style={styles.placeholderSubtitle}>Support camera or album selection, AI auto-recognition</div>
          </div>
        )}
      </div>
      <input type="file" accept="image/*" onChange={onFileChange} style={{ display: 'none' }} id="upload-input-web" />
      {ocrLoading && <div style={styles.ocr}>Recognizing...</div>}
      {!ocrLoading && ocrInfo?.confidence != null && (
        <div style={styles.confidenceRow}>
          <div style={styles.confidenceBox}>
            <div style={styles.confidenceLabel}>AI Recognition Confidence</div>
            <div style={styles.confidenceValue}>{Math.round((ocrInfo.confidence || 0) * 100)}%</div>
          </div>
          <div>
            <button onClick={onChangeImage} style={styles.changeBtn}>Change Image</button>
          </div>
        </div>
      )}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  card: { background: '#fff', padding: 20, borderRadius: 12, marginBottom: 16 },
  title: { fontSize: 18, fontWeight: 700, marginBottom: 12 },
  dropzone: { borderRadius: 8, border: '2px dashed #e5e7eb', minHeight: 160, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', overflow: 'hidden' },
  placeholder: { textAlign: 'center', color: '#9CA3AF' },
  icon: { fontSize: 28, marginBottom: 6 },
  placeholderTitle: { fontSize: 16, fontWeight: 600, marginBottom: 4, color: '#6B7280' },
  placeholderSubtitle: { fontSize: 12, color: '#9CA3AF' },
  preview: { maxWidth: '100%', maxHeight: 280, objectFit: 'cover', borderRadius: 8 },
  ocr: { marginTop: 8, fontSize: 13, color: '#666' },
};

export default UploadReceiptImageWeb;
